import {
    SUBMIT_MONTHLY_COLLECTION_REQUEST,
    SUBMIT_MONTHLY_COLLECTION_SUCCESS,
    SUBMIT_MONTHLY_COLLECTION_FAIL,
    SUBMIT_MONTHLY_COLLECTION_RESET,
    GET_MY_MONTHLY_COLLECTIONS_REQUEST,
    GET_MY_MONTHLY_COLLECTIONS_SUCCESS,
    GET_MY_MONTHLY_COLLECTIONS_FAIL,
    GET_MY_MONTHLY_COLLECTIONS_RESET,
    GET_MY_MONTHLY_STATISTICS_REQUEST,
    GET_MY_MONTHLY_STATISTICS_SUCCESS,
    GET_MY_MONTHLY_STATISTICS_FAIL,
    GET_MY_MONTHLY_STATISTICS_RESET,
    UPDATE_MONTHLY_COLLECTION_REQUEST,
    UPDATE_MONTHLY_COLLECTION_SUCCESS,
    UPDATE_MONTHLY_COLLECTION_FAIL,
    UPDATE_MONTHLY_COLLECTION_RESET,
    DELETE_MONTHLY_COLLECTION_REQUEST,
    DELETE_MONTHLY_COLLECTION_SUCCESS,
    DELETE_MONTHLY_COLLECTION_FAIL,
    DELETE_MONTHLY_COLLECTION_RESET,
} from '../constants/monthlyCollectionConstants';

export const submitMonthlyCollectionReducer = (state = {}, action) => {
    switch (action.type) {
        case SUBMIT_MONTHLY_COLLECTION_REQUEST:
            return { loadingSubmitMonthlyCollection: true };
        case SUBMIT_MONTHLY_COLLECTION_SUCCESS:
            return {
                loadingSubmitMonthlyCollection: false,
                submitMonthlyCollectionData: action.payload,
            };
        case SUBMIT_MONTHLY_COLLECTION_FAIL:
            return {
                loadingSubmitMonthlyCollection: false,
                errorSubmitMonthlyCollection: action.payload,
            };
        case SUBMIT_MONTHLY_COLLECTION_RESET:
            return {};
        default:
            return state;
    }
};

export const getMyMonthlyCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_MY_MONTHLY_COLLECTIONS_REQUEST:
            return { loadingMyMonthlyCollections: true };
        case GET_MY_MONTHLY_COLLECTIONS_SUCCESS:
            return {
                loadingMyMonthlyCollections: false,
                myMonthlyCollectionsData: action.payload,
            };
        case GET_MY_MONTHLY_COLLECTIONS_FAIL:
            return {
                loadingMyMonthlyCollections: false,
                errorMyMonthlyCollections: action.payload,
            };
        case GET_MY_MONTHLY_COLLECTIONS_RESET:
            return {};
        default:
            return state;
    }
};

export const getMyMonthlyStatisticsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_MY_MONTHLY_STATISTICS_REQUEST:
            return { loadingMyMonthlyStatistics: true };
        case GET_MY_MONTHLY_STATISTICS_SUCCESS:
            return {
                loadingMyMonthlyStatistics: false,
                myMonthlyStatisticsData: action.payload,
            };
        case GET_MY_MONTHLY_STATISTICS_FAIL:
            return {
                loadingMyMonthlyStatistics: false,
                errorMyMonthlyStatistics: action.payload,
            };
        case GET_MY_MONTHLY_STATISTICS_RESET:
            return {};
        default:
            return state;
    }
};

export const updateMonthlyCollectionReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_MONTHLY_COLLECTION_REQUEST:
            return { loadingUpdateMonthlyCollection: true };
        case UPDATE_MONTHLY_COLLECTION_SUCCESS:
            return {
                loadingUpdateMonthlyCollection: false,
                updateMonthlyCollectionData: action.payload,
            };
        case UPDATE_MONTHLY_COLLECTION_FAIL:
            return {
                loadingUpdateMonthlyCollection: false,
                errorUpdateMonthlyCollection: action.payload,
            };
        case UPDATE_MONTHLY_COLLECTION_RESET:
            return {};
        default:
            return state;
    }
};

export const deleteMonthlyCollectionReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_MONTHLY_COLLECTION_REQUEST:
            return { loadingDeleteMonthlyCollection: true };
        case DELETE_MONTHLY_COLLECTION_SUCCESS:
            return {
                loadingDeleteMonthlyCollection: false,
                deleteMonthlyCollectionData: action.payload,
            };
        case DELETE_MONTHLY_COLLECTION_FAIL:
            return {
                loadingDeleteMonthlyCollection: false,
                errorDeleteMonthlyCollection: action.payload,
            };
        case DELETE_MONTHLY_COLLECTION_RESET:
            return {};
        default:
            return state;
    }
};